import { useEffect, useRef, useContext } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Map from './map/Map';
import LoactionContext from '../context/LocationContext';

const NewAddressForm = ({ active, callBack, editData }) => {
  const { locationData, setUpdate } = useContext(LoactionContext);
  const formRef = useRef(null);
  const position = useRef(null);

  const saveNewAddress = (e) => {
    e.preventDefault();

    const receiver = formRef.current.receiver.value;
    const address = formRef.current.address.value;
    const phone = parseInt(Number(formRef.current.phone.value), 10).toString();
    const postcode = formRef.current.postcode.value;
    const latitude = position.current.lat.toString();
    const longitude = position.current.lng.toString();
    const affiliation_id = '1';

    const mobileReg = /^0?9[0-9]{9}/;
    const postcodeReg = /\b(?!(\d)\1{3})[13-9]{4}[1346-9][013-9]{5}\b/;

    if (
      address.trim() === '' ||
      receiver.trim() === ''
      // latitude.trim() === '' ||
      // longitude.trim() === ''
    ) {
      toast.error('لطفا همه فیلد هارا پر کنید');
      return;
    }

    if (!mobileReg.test(phone)) {
      toast.error('لطفا یک شماره تماس معتبر وارد کنید');
      return;
    }

    if (!postcodeReg.test(postcode)) {
      toast.error('لطفا کد پستی معتبر وارد کنید');
      return;
    }

    const formData = new FormData();
    formData.append('receiver', receiver);
    formData.append('address', address);
    formData.append('phone', phone);
    formData.append('postcode', postcode);
    formData.append('latitude', latitude);
    formData.append('longitude', longitude);
    !editData && formData.append('affiliation_id', affiliation_id);

    const fetcherPost = async () => {
      try {
        await fetch('/api/user/addresses', {
          method: 'POST',
          headers: {
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')
              .content,
          },
          body: formData,
        });

        setUpdate((prev) => !prev);
        // callBack(false);
        toast.success('اطلاعات جدید ذخیره شد');
      } catch (error) {
        console.log(error);
      }
    };

    const fetcherPut = async () => {
      try {
        await fetch(
          `https://hamrahyper.ir/api/user/addresses/${editData.id}/update`,
          {
            method: 'POST',
            headers: {
              'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            body: formData,
          }
        );

        setUpdate((prev) => !prev);
        // callBack(false);
        toast.success('اطلاعات جدید ذخیره شد');
      } catch (error) {
        console.log(error);
      }
    };

    if (editData) {
      fetcherPut();
    } else {
      fetcherPost();
    }
  };

  const locationPosition = (latlng) => {
    position.current = latlng;
  };

  useEffect(() => {
    const form = formRef.current;

    const closest = (e) => {
      if (
        !e.target.classList.contains('add-new-address') &&
        !e.target.closest('.address-form')
      ) {
        callBack(false);
      }
    };

    window.addEventListener('click', closest);

    return () => {
      window.removeEventListener('click', closest);
      form.reset();
    };
  }, [callBack]);

  return (
    <>
      <ToastContainer position='bottom-right' rtl theme='colored' />

      <div
        className={`fixed z-30 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full flex justify-center items-center transition-all`}
        style={{
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          display: active ? 'block' : 'none',
          pointerEvents: active ? 'unset' : 'none',
        }}>
        <form
          style={{ width: '90%' }}
          className={`address-form content sm:w-1/2 flex flex-col gap-5 justify-between items-end bg-slate-100 shadow-xl p-5 rounded-lg`}
          ref={formRef}>
          <h2 className='px-2'>افزودن آدرس جدید</h2>

          <input
            type='text'
            placeholder='گیرنده'
            id='receiver'
            name='receiver'
            className='w-full text-right p-2'
            defaultValue={editData && editData.receiver}
          />
          <input
            type='text'
            placeholder='آدرس'
            id='address'
            name='address'
            className='w-full text-right p-2'
            defaultValue={editData && editData.address}
          />
          <input
            type='number'
            placeholder='تلفن'
            id='phone'
            name='phone'
            className='w-full text-right p-2'
            defaultValue={editData && editData.phone}
          />
          <input
            type='number'
            placeholder='کد پستی'
            id='postcode'
            name='postcode'
            className='w-full text-right p-2'
            defaultValue={editData && editData.postcode}
          />

          <Map
            height={'15rem'}
            callBack={locationPosition}
            location={
              editData
                ? [
                    locationData.defLocationData.latitude,
                    locationData.defLocationData.longitude,
                  ]
                : [29.620207, 51.652271]
            }
          />

          <button
            type='submit'
            className='p-2 w-full bg-slate-700 text-white rounded-xl hover:bg-slate-600 transition-all active:scale-90'
            onClick={saveNewAddress}>
            تایید
          </button>
        </form>
      </div>
    </>
  );
};

export default NewAddressForm;
